import { graphql } from '@/generated/gql';

export const SUPPLIER_GEO_QUERY = graphql(/* GraphQL */ `
  query SupplierGeo($offset: Int, $limit: Int, $filter: JSON) {
    suppliersGeo(offset: $offset, limit: $limit, filter: $filter) {
      type
      features {
        type
        geometry {
          type
          coordinates
        }
        properties {
          id
          name
          relationship
        }
      }
    }
  }
`);
